import {
  Avatar,
  AvatarGroup,
  Box,
  Center,
  DarkMode,
  Flex,
  Heading,
  HStack,
  Stack,
  Text,
  useBreakpointValue,
  useColorModeValue as mode,
  Image,
} from '@chakra-ui/react'
// import { SignInForm } from './SignInForm'
import { LoginFormHandle } from '../containers';

export const Login = () => (
  <Flex
    width={'full'}
    minH={{ base: 'auto', md: '100vh' }}
    bgGradient={{
      md: mode(
        'linear(to-r, blue.600 50%, white 50%)',
        'linear(to-r, blue.600 50%, gray.900 50%)',
      ),
    }}
  >
    <Flex maxW="8xl" mx="auto" width="full">
      <Box flex="1" display={{ base: 'none', md: 'block' }}>
        <DarkMode>
          <Flex direction="column" px={{ base: '4', md: '8' }} height="full" color={"white"}>
            <Flex align="center" h="24">
              <Image
                height={'60px'}
                objectFit='contain'
                src='/assets/images/brand/greatpay.png'
                alt='GreatPay Logo'
              />
            </Flex>
            <Flex flex="1" align="center">
              <Stack spacing="8">
                <Stack spacing="6">
                  <Heading size={{ md: '2xl', xl: '3xl' }}>
                    Start making your dreams come true
                  </Heading>
                  <Text fontSize="lg" maxW="md" fontWeight="medium">
                  Log in to your account and discover the worlds' best card managment system.
                  </Text>
                </Stack>
                <HStack spacing="4">
                  <AvatarGroup
                    size="md"
                    max={useBreakpointValue({ base: 2, lg: 5 })}
                    borderColor="on-accent"
                  >
                    <Avatar name="Alfyns BANK" src="/assets/images/brand/alfyns.png" />
                    <Avatar name="Alfyns Finance" src="/assets/images/brand/alfyns.jpg" />
                    <Avatar name="Wat and co" src="/assets/images/brand/wat-co.png" />
                    <Avatar name="Alfyns Finance" src="/assets/images/brand/alfyns.jpg" />
                    <Avatar name="Wat and co" src="/assets/images/brand/wat-co.png" />
                  </AvatarGroup>
                  <Text fontWeight="medium">Join 10.000+ banks</Text>
                </HStack>
              </Stack>
            </Flex>
            <Flex align="center" h="24">
              <Text color="on-accent-subtle" fontSize="sm">
                © 2023 Buenco. All rights reserved.
              </Text>
            </Flex>
          </Flex>
        </DarkMode>
      </Box>
      <Center flex="1">
        <LoginFormHandle />
      </Center>
    </Flex>
  </Flex>
)